import {
	CheckupResultKeys,
	Checkups,
} from '@home-diy-toolbox/web/common-types/refresh-base';

export const RESULT_PAGES = {
	[Checkups.BATTERY]: CheckupResultKeys.BATTERY_RESULT_LOADING,
} as const;
